module.exports = __webpack_public_path__ + "static/media/logo-white.6058768c.png";